import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import OrganizationList from "./OrganizationList";
import OrganizationAddress from "./OrganizationAddress";
import OrganizationContact from "./OrganizationContact";
import OrganizationImages from "./OrganizationImages";
import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import {
  getStoredOrganizationId,
  getStoredUserId,
  setStoredOrganizationId,
} from "./organizationStorage";
import { getOrganizationTab } from "./Header";

import './css/dashboard.css';

const Dashboard = () => {
  const location = useLocation();
  const [organizationId, setOrganizationId] = useState(null);
  const [status, setStatus] = useState("");
  const activeTab = getOrganizationTab("admin", location.search);

  // Fetch organizationId and status for Images tab
  useEffect(() => {
    const loadOrganizationContext = async () => {
      try {
        const token = localStorage.getItem("Token");
        let orgId = getStoredOrganizationId();
        const userId = getStoredUserId();

        if (!orgId && userId) {
          const linkResponse = await axiosOrganizationInstance.get(
            `/organization/user/${userId}/organization`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          orgId = String(linkResponse.data.organizationId);
          setStoredOrganizationId(orgId);
        }

        if (!orgId) {
          setOrganizationId(null);
          return;
        }

        setOrganizationId(orgId);

        const response = await axiosOrganizationInstance.get(`/organization/${orgId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setStatus(response.data?.status || "");
      } catch (error) {
        console.error("Error fetching organization status:", error);
      }
    };

    loadOrganizationContext();
  }, []);

  switch (activeTab) {
    case "Address":
      return <OrganizationAddress />;
    case "Contacts":
      return <OrganizationContact />;
    case "Images":
      return <OrganizationImages organizationId={organizationId} status={status} editMode={false} />;
    case "Details":
    default:
      return <OrganizationList />;
  }
};

export default Dashboard;
